export default __webpack_public_path__ + "static/media/left-line.3b192b37.svg";